export const titleCase = (value) =>
  String(value || "")
    .replace(/[_-]/g, " ")
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const valueOrDash = (value) => String(value || "").trim() || "Not set";

export const formatDate = (value) => {
  if (!value) return "Not set";
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return "Not set";
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

export const contentSummary = (details) => {
  const sections = details?.parsedContent?.sections || [];
  const sectionData = (type) => sections.find((section) => section.type === type)?.data || {};
  const hero = sectionData("HERO");
  const about = sectionData("ABOUT");
  const contact = sectionData("CONTACT");
  const website = details?.website || {};
  return {
    headline: hero.headline || about.businessName || website.name || "",
    tagline: hero.tagline || hero.subheadline || website.tagline || "",
    phone: contact.primaryPhone || contact.phone || "",
    email: contact.primaryEmail || contact.email || "",
    city: contact.city || contact.location || "",
  };
};

export const websiteOwnerTypeForWorkspace = ({
  isOrganizationWorkspace,
  selectedWorkspace,
  searchOwnerType,
} = {}) => {
  const queryType = String(searchOwnerType || "").toUpperCase();
  if (queryType === "BUSINESS" || queryType === "PORTFOLIO") return queryType;
  if (
    isOrganizationWorkspace ||
    String(selectedWorkspace?.accountType || "").toUpperCase() === "ORGANIZATION" ||
    Boolean(selectedWorkspace?.organizationId)
  ) {
    return "BUSINESS";
  }
  return "PORTFOLIO";
};

const linesToTitleDescription = (value) =>
  (value || "").split("\n").map((line) => {
    const [title, ...rest] = line.split("-");
    return { title: title?.trim(), description: rest.join("-").trim() };
  }).filter((item) => item.title);

const linesToStats = (value) =>
  (value || "").split("\n").map((line) => {
    const [valuePart, label] = line.split("-");
    return { value: valuePart?.trim(), label: label?.trim(), suffix: "" };
  }).filter((item) => item.value || item.label);

export const buildOverrides = (values, ownerType = "BUSINESS") => {
  const services = JSON.stringify(linesToTitleDescription(values.services));
  const stats = JSON.stringify(linesToStats(values.stats));

  if (ownerType === "PORTFOLIO") {
    return {
      fullName: values.businessName || "",
      jobTitle: values.industry || "",
      primaryColor: values.primaryColor || "#27ae30",
      secondaryColor: values.secondaryColor || "#C9F2CB",
      headline: values.headline || "",
      tagline: values.tagline || "",
      ctaText: values.ctaText || "Contact Me",
      shortBio: values.shortDescription || "",
      longBio: values.story || "",
      services,
      stats,
      phone: values.phone || "",
      email: values.email || "",
      city: values.city || "",
      address: values.address || "",
      facebook: values.facebook || "",
      instagram: values.instagram || "",
      twitter: values.twitter || "",
      linkedin: values.linkedin || "",
      youtube: values.youtube || "",
    };
  }

  return {
  businessName: values.businessName || "",
  tagline: values.tagline || "",
  primaryColor: values.primaryColor || "#27ae30",
  secondaryColor: values.secondaryColor || "#C9F2CB",
  headline: values.headline || "",
  subheadline: values.subheadline || "",
  heroTagline: values.heroTagline || "",
  ctaText: values.ctaText || "Contact Us",
  shortDescription: values.shortDescription || "",
  story: values.story || "",
  mission: values.mission || "",
  vision: values.vision || "",
  services,
  stats,
  phone: values.phone || "",
  email: values.email || "",
  city: values.city || "",
  address: values.address || "",
  facebook: values.facebook || "",
  instagram: values.instagram || "",
  twitter: values.twitter || "",
  linkedin: values.linkedin || "",
  youtube: values.youtube || "",
  };
};
